import i18n from '../i18n'
import { KeyValue } from '../models'

/**
 * 授权点的名称根据当前选择的语言，如果找不到，则用英文
 * @param name 
 */
export const getAuthPointI18n = (name: KeyValue[]) => {
    return name?.find(item => item.key === i18n.language)?.value || name?.find(item => item.key === 'EN')?.value || ''
}


/**
 * 将集团/餐厅列表用的 `setting_restaurant_operating_status` 编码转为 i18n key。
 * @param status 后端字符串编码 `'1'`…`'8'`
 * @returns 文案 key，未知编码时回退为营业
 */
// 餐厅 1.营业，2.歇业 3.换DITTA 4.转让 5.暂停营业 6.更换系统 7.已暂停(SOSRESO) 8.已取消(ANNULLATO)
export const getRestaurantStatusText = (status: string): string => {
    // 定义餐厅类型映射（与后端 setting_restaurant_operating_status 取值一致）
    const statusMapping: { [key: string]: string } = {
        '1': 'restaurant_info_page_restaurant_open',
        '2': 'restaurant_info_page_restaurant_close',
        '3': 'restaurant_page_text_restaurant_change_ditta',
        '4': 'restaurant_info_page_restaurant_transfer',
        '5': 'restaurant_info_page_restaurant_pause',
        '6': 'restaurant_info_page_restaurant_changed_system',
        '7': 'restaurant_info_page_restaurant_sosreso',
        '8': 'restaurant_info_page_restaurant_annullato'
    };

    // 返回对应的状态文本
    return statusMapping[status] || 'restaurant_info_page_restaurant_open';
}